import React, { Component } from 'react'

class ShowKeywords extends Component {
    render() {
        const {meta_keywords} = this.props;
        return (
            <div>
                <div className="chip fadeinup">
                    Từ khoá:
                </div>
                {meta_keywords ? 
                    meta_keywords.split(',').map((keyword, index) => (
                        index+1 < meta_keywords.split(',').length ? 
                        <div className={`chip fadeinup ${index === 0 ? 'bgSuccess textWhite' : ''}`} key={index}>
                            <span>{keyword}</span>
                        </div>
                        : ''
                    )):
                    <div className="chip fadeinup">
                        Không có từ khoá nào
                    </div>
                }
            </div>
        )
    }
}

export default ShowKeywords
